import * as React from 'react'
import * as ReactDOM from 'react-dom'
import Sections from './components/section'
import {Base64 } from 'js-base64';
import {decode} from 'html-entities';
class WidgetHandlerClass extends elementorModules.frontend.handlers.Base {
	getDefaultSettings() {
		return {
			selectors: {
				app: '.ecf-form-donate',
			},
		};
	}

	getDefaultElements() {
		const selectors = this.getSettings( 'selectors' );
		return {
			$app: this.$element.find( selectors.app ),
		};
	}

	bindEvents() {
		let data = JSON.parse(decode(Base64.decode(this.elements.$app[0].getAttribute( 'data')), {level: 'html5'}));
		let json_data = JSON.parse(data);
		ReactDOM.render(<App data={json_data} />, this.elements.$app[0])
	}
}

jQuery( window ).on( 'elementor/frontend/init', () => {
	const addHandler = ( $element ) => {
		elementorFrontend.elementsHandler.addHandler( WidgetHandlerClass, {
			$element,
		} );
	};

	elementorFrontend.hooks.addAction( 'frontend/element_ready/efc_form_donate.default', addHandler );
} );

class App extends React.Component {

	constructor(props){
		super(props);
		let data = props;
		this.state = {
			data: data
		}
	}

	render() {
		let {data} = this.state;
		return (
			<div className="ecf-form-donate__container" >
				<Sections data={data} />
            </div>
		)
	}
}
